exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal--24AvD {\n  max-width: 600px;\n}\n\n.modal-content--2nIad {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  width: 100%;\n}\n\n.summary--1kfGf {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  text-align: center;\n  font-weight: 400;\n  margin-bottom: 20px;\n}\n\n.summary--1kfGf .button--3Jw7q {\n  max-width: 200px;\n}\n\n.submit--3XCpr {\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.submit--3XCpr .button--3Jw7q {\n  margin: 10px;\n}\n", ""]);

// exports
exports.locals = {
	"modal": "modal--24AvD",
	"modal-content": "modal-content--2nIad",
	"summary": "summary--1kfGf",
	"button": "button--3Jw7q",
	"submit": "submit--3XCpr"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"minimize":false,"sourceMap":false,"localIdentName":"[local]--[hash:base64:5]","importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false,"plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js?{"data":"$env: production;","sourceMap":false,"outputStyle":"expanded","precision":10,"includePaths":["/app/node_modules","/app/src"]}!./src/components/emission/cards/controls/CardResetPinCountControl/CardResetPinCountControl.m.scss
// module id = 1418
// module chunks = 0